import React from 'react';

const AccessDenied = (): JSX.Element => (
  <div>
    <h1> Página no encontrada.</h1>
  </div>
);

export default AccessDenied;
